module.exports = __webpack_public_path__ + "img/ic_close.ee331d11.svg";